export default __webpack_public_path__ + "static/media/radar.9888ac73.png";